module.exports = __webpack_public_path__ + "img/newEnergy.765876e0.png";